import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { useQuery } from '@tanstack/react-query'
import { ApiKey } from 'features/incidents/components/enums'

export type GetFeatureParams = {
  insurancePlanId: number
}

export const getFeatures = async (params: GetFeatureParams) => {
  return axios.get(endpoints.getFeatures, { params })
}

export const useGetFeatures = (params: GetFeatureParams) => {
  return useQuery([ApiKey.features, ApiKey.list, params], () => getFeatures(params), {
    enabled: params.insurancePlanId > 0,
  })
}
